/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsisRuleDelete
 */
export interface OsisRuleDelete {
    /**
     * 
     * @type {string}
     * @memberof OsisRuleDelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleDelete
     */
    deleted?: boolean;
}

export function OsisRuleDeleteFromJSON(json: any): OsisRuleDelete {
    return OsisRuleDeleteFromJSONTyped(json, false);
}

export function OsisRuleDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function OsisRuleDeleteToJSON(value?: OsisRuleDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


